// Browser polyfills
import 'whatwg-fetch';

// Libs
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Layout, Result, Drawer, Tooltip } from 'antd';
import NackleMenu from '@nackle/menu';
const { Content } = Layout;
import ReactMarkdown from 'react-markdown';
import userguide from './user-guide.md';

// Routing
import { Route, Link, routeHistory } from '@nackle/biw-web-router';
import { routes, bundleRoutingMiddleware } from './app-routing.jsx';

// Bridge
import { Bridge } from '@nackle/bridge';
import auth, {
  authRouteMiddleware,
  authRequestMiddleware
} from './app-auth.js';

import biwrouter from '@nackle/biw-web-router';

// Fetch
import { applyRequestMiddleware } from './utils/fetch';

// Components
import AppHeader from './components/app-header/app-header.jsx';
import AppFooter from './components/app-footer/app-footer.jsx';
import AppError from './components/app-error/app-error.jsx';
import { EcardLoading } from './components/icons/icons.jsx';
import Cbot from './assets/images/chatbot.png';

// Services
import CMXService from './services/cmx';
// import PermissionService from './services/permissions';

// Styles
import './styles/app.less';

/*******************************************************************************
 *  1. App (root level component)
 */
class App extends React.Component {
  state = {
    cmxBundleLoaded: false,
    user: this.props.user ? this.props.user : {},
    loading: true,
    visible: false,
    companyId: '',
    permissions: []
  };

  showDrawer = () => {
    console.log( 'clicked' );
    this.setState( {
      visible: true
    } );
  };
  onClose = () => {
    this.setState( {
      visible: false
    } );
  };

  setCompanyId = ( companyId ) => {
    this.setState( {
      companyId: companyId
    } );
  };

  render() {
    const { cmxBundleLoaded, permissions, user } = this.state;
    const setLoading = () => {
      this.setState( {
        loading: false
      } );
    };

    return (
      <AppError>
        <Route
          render={ ( route ) => {
            document.title = route && route.match ? route.match.title : 'Home';
            const companyId = route.state?.params?.companyId;
            return (
              <>
                { this.state.loading && (
                  <EcardLoading content="Loading Ecard Studio..."></EcardLoading>
                ) }
                <Bridge
                  auth={ auth }
                  onSignIn={ this.handleSignIn }
                  onAuthStateChange={ this.handlePermissionChange }
                  onSessionExpired={ ( e ) => {
                    e.preventDefault();
                    alert( 'Your session has expired.' );
                    auth.signOut();
                  } }
                >
                  { this.state.user.claims ? (
                    <Layout className="root-layout">
                      <AppHeader
                        companyId={ companyId }
                        user={ user }
                        signOut={ auth.signOut }
                        loading={ setLoading }
                        currentPath={ route }
                        setCompanyId={ this.setCompanyId }
                      />
                      <Layout>
                        <NackleMenu
                          auth={ auth }
                          cmxBundleLoaded={ cmxBundleLoaded }
                          visible={ false }
                        />
                        <Drawer
                          title="Frequently Asked Questions"
                          placement="right"
                          closable={ false }
                          onClose={ this.onClose }
                          open={ this.state.visible }
                          className="ecard-faq-wrapper"
                        >
                          <ReactMarkdown>
                            { userguide }
                          </ReactMarkdown>
                        </Drawer>
                        <Tooltip
                          placement="left"
                          color={ '#1890ff' }
                          title="Click To View User Guide"
                        >
                          <div
                            className="card-footer-pointer card-user-guide"
                            onClick={ () => this.showDrawer() }
                          >
                            <span>
                              <img src={ Cbot } alt="" width="75px" />
                            </span>
                          </div>
                        </Tooltip>

                        <Layout className="page-layout">
                          <Content className="app-content">
                            { route.match ? (
                              <div>
                                { permissions && permissions.length ? (
                                  <div className="container">
                                    { React.cloneElement( route.component, {
                                      companyId,
                                      permissions
                                    } ) }
                                  </div>
                                ) : (
                                  <Content className="app-content">
                                    <Result
                                      className="ecard-warning"
                                      status="warning"
                                      title="Permission Needed!"
                                      subTitle="Sorry, you do not have permissions to Ecard Studio!"
                                      extra={
                                        <Link
                                          to={ companyId ? `/${ companyId }` : '/' }
                                          className="ant-btn ant-btn-primary"
                                        >
                                          Back Home
                                        </Link>
                                      }
                                    />
                                  </Content>
                                ) }
                              </div>
                            ) : (
                              <Result
                                status="404"
                                title="404"
                                subTitle="Sorry, the page you visited does not exist."
                                extra={
                                  <Link
                                    to={ companyId ? `/${ companyId }` : '/' }
                                    className="ant-btn ant-btn-primary"
                                  >
                                    Back Home
                                  </Link>
                                }
                              />
                            ) }
                          </Content>
                          <AppFooter />
                        </Layout>
                      </Layout>
                    </Layout>
                  ) : (
                    <EcardLoading content="Loading Ecard Studio..."></EcardLoading>
                  ) }
                </Bridge>
              </>
            );
          } }
        />
      </AppError>
    );
  }

  handleSignIn = async ( user ) => {
    const cmxService = new CMXService( auth.state );
    await cmxService.loadBundles( [ 'navigation' ] );
    await biwrouter.routeHistory.refresh();
    this.setState( { cmxBundleLoaded: true } );
    this.setState( {
      user,
      companyId: auth.state.claims.company_id,
      permissions: auth.state.claims.permissions[ 'ecards' ] || []
    } );
  };

  handlePermissionChange = async ( authState ) => {
    await biwrouter.routeHistory.refresh();
    this.setState( {
      permissions: authState.claims.permissions[ 'ecards' ] || [],
      user: authState
    } );
  };
}

/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware, bundleRoutingMiddleware ] );

/*******************************************************************************
 *  3. Connect Auth to Fetch
 */
applyRequestMiddleware( authRequestMiddleware );

/*******************************************************************************
 * 4. Render the the app
 */

const container = document.getElementById( 'app-root' );
const root = ReactDOM.createRoot( container );

root.render( <App /> );
